module.exports = {
  basePaths: {
    masters: "/masters",
  },
  masters: {
    translation: {
      list: "/masters/translation/list",
      add: "/masters/translation/add",
      edit: "/masters/translation/:id",
    },
    cms: {
      list: "/masters/cms/list",
      add: "/masters/cms/add",
      edit: "/masters/cms/:id",
    },
    emailTemplate: {
      list: "/masters/email-templates/list",
      add: "/masters/email-templates/add",
      edit: "/masters/email-templates/:id",
    },
    smsTemplate: {
      list: "/masters/sms-templates/list",
      add: "/masters/sms-templates/add",
      edit: "/masters/sms-templates/:id",
    },
    reportedUsers: {
      list: "/masters/reported-users/list",
    },
    serviceCategory: {
      list: "/masters/service-categories/list",
      add: "/masters/service-categories/add",
      edit: "/masters/service-categories/:id",
    },
    subscriptionPlan: {
      list: "/masters/subscription-plans/list",
      add: "/masters/subscription-plans/add",
      edit: "/masters/subscription-plans/:id",
    },
    subscribedUsers: {
      list: "/masters/subscribed-users/list",
      view: "/masters/subscribed-users/:id/view",
    },
    referralRecords: {
      list: "/masters/referral-records/list",
      view: "/masters/referral-records/:id/view",
    },
    communityLeaderboard: {
      list: "/masters/community-leaderboard/list",
    },
  },
  weAllTeam: {
    inbox: "/weall-team-messages/inbox",
    newMessage: "/weall-team-messages/new",
    conversation: "/weall-team-messages/conversation/:id",
  },
  contentModeration: {
    groups: {
      list: "/content-moderation/groups/list",
      view: "/content-moderation/groups/:id/view",
    },
    communities: {
      list: "/content-moderation/communities/list",
      view: "/content-moderation/communities/:id/view",
    },
    activities: {
      list: "/content-moderation/activities/list",
      view: "/content-moderation/activities/:id/view",
    },
    feedPosts: {
      list: "/content-moderation/feed-posts/list",
      view: "/content-moderation/feed-posts/:id/view",
    },
  },
  userMaster: {
    list: "/user/list",
    edit: "/user/:id/edit",
    view: "/user/:id/view",
  },
  dummyUser: {
    list: "/user/dummy/list",
    add: "/user/dummy/add",
    edit: "/user/dummy/:id/edit",
    view: "/user/dummy/:id/view",
  },
  freelancerUser: {
    list: "/user/freelancer/list",
    view: "/user/freelancer/:id/view",
    serviceView: "/user/freelancer/:id/service/:serviceId/view",
  },
  review: {
    list: "/reviews/list",
    view: "/reviews/:id/view",
  },
  dashboard: "/dashboard",
  profile: "/edit-profile",
  changePassword: "/change-password",
  notFoundPage: "/404",
  signIn: "/sign-in",
  auth: {
    forgotPassword: "/forgot-password",
    signIn: "/sign-in",
  },
  notification: {
    list: "/notification-list",
  },
  settings: {
    general: "/settings/general-settings",
    referral: "/settings/referral-settings",
    adminRewards: "/settings/admin-rewards-settings",
  },
};
